// Imported FIRST by main.js so it runs before any other module's top level can touch storage (job #768).
import { installSafeStorage } from './safeStorage'

if (typeof window !== 'undefined') installSafeStorage()
